<template>
  <ClientOnly>
  <Transition name="slide-fade">
    <div
      class="sideBar-container"
      :class="{ 'filterbar-mobile-flat': props.callFrom === 'fiterSideBar' }"
      v-if="props.showSideBar || width>= props.breakPoint"
    >
            <slot/>
    </div>
  </Transition>
  </ClientOnly>
  <ClientOnly>
    <Transition name="overlay-trasition">
      <div v-if="props.showSideBar && width<props.breakPoint" class="overlay" @click="emit('update:showSideBar' , false)"></div>
    </Transition>
    </ClientOnly>
  </template>
  
  
  <script setup lang="ts" >
  const { width } = useWindowSize();
  const { query } = useRoute();
    const searchStore = useSearchStore();
    const router = useRouter();

  const props = defineProps({
    showSideBar: { type: Boolean, default: false},
    breakPoint : {type: Number, default: 0},
    callFrom: { type: String, default: '' },

    });
    const emit = defineEmits<{
    (e: 'update:showSideBar', val: boolean): void
    }>()
        

onBeforeMount(async ()=>{

  // Apply search on page refresh and when a query ID is present in mobile
  if (!props.showSideBar) {
      /*if (Object.keys(query).length === 0 && !searchStore.getFetchResult?.announcements?.length) {      
        //searchStore.fetchAnnounce(1, dashStore.getUserProfil.id);
      }*/
      if(query && (width.value < props.breakPoint)){
        
        searchStore.userInput = await initializeInputs(searchStore.getUserInput, searchStore, query);   
        searchStore.selectedInput = toRaw(searchStore.userInput);
        const forwardPath = String(router.options.history.state?.forward ?? '')
        const cameFromVoituresDetails = forwardPath.includes("/voitures/")
        if(!cameFromVoituresDetails){
            // Listing page controls fetch order (promoted first, then search-result).
        }
        
      }
  }
   
    
})
  </script>
  <style lang="scss" scoped>

  </style>
